export const
    ACCESS_TOKEN_PENDING = 'access_token_pending',
    ACCESS_TOKEN_FAILED = 'access_token_failed',
    ACCESS_TOKEN_DOWNLOADED = 'access_token_downloaded',
    ACCESS_TOKENS_DOWNLOADED = 'access_tokens_downloaded',
    ACCESS_TOKEN_DELETED = 'access_token_deleted',
    ACCESS_TOKEN_POSTING = 'access_token_posting';



// WEBPACK FOOTER //
// src/store/accessTokens/types.js